import {useSelector} from 'react-redux'

/**
 * Default empty staff object returned when staff is not found.
 */
const EMPTY_STAFF = {
  displayName: '',
  buildings: [],
  messages: [],
}

/**
 * Creates a getStaff function for the given lookup.
 * Shared utility used by both useStaffLookup and useCombinedStaffLookup.
 *
 * @param {Object} staffLookup
 * @return {Function} getStaff function
 */
export const createGetStaff = staffLookup => staffId => {
  const staff = staffLookup[staffId]
  return staff || EMPTY_STAFF
}

function useStaffLookup() {
  const staffLookup = useSelector(state => state.Staff.staffLookup)

  return {
    getStaff: createGetStaff(staffLookup),
  }
}

export default useStaffLookup
